import { connect } from 'react-redux';
import { updateGroupCohorts, updateGroupCohortsVisibility } from 'actions/partner';
import {
  enqueueGroupCohortsCSVReport,
} from 'actions/groupCohorts';

import { getLoaders } from 'selectors';
import { showReportDetailsModal } from 'actions/internal';
import GroupCohortsGeneralFilter from 'components/filters/GroupCohortsGeneralFilter';
import _ from 'lodash';

const mapStateToProps = (state) => {
  return {
    meta: state.meta.groupCohorts,
    groups: state.filters.groups,
    csvReport: state.groupCohortsCSVReport,
    withScope: state.filters.withScope,
    periods: state.filters.periods,
    isLoading: getLoaders(state, ['REPORT_GROUP_COHORT_FILTER', 'REPORT_GROUP_COHORT']),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onWithCohortsChange: (withcohorts) => {
      dispatch(updateGroupCohorts({withcohorts, page: 1}))
    },
    onColumnVisibilityChange: (withages) => {
      dispatch(updateGroupCohortsVisibility({withages}));
    },
    onGroupChange: (groups) => {
      dispatch(updateGroupCohorts({groups, page: 1}))
    },
    onCSVEnqueue: _.debounce(() => {
      dispatch(enqueueGroupCohortsCSVReport());
    }, 500),
    onCSVReportDetailsShow: (report) => {
      dispatch(showReportDetailsModal(report, 'GROUP_COHORTS_REPORT_DETAILS'));
    },
    onPeriodChange: (start, end) => {
      dispatch(updateGroupCohorts({start, end, page: 1}));
    },
  }
}

const GroupCohortsFilterContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupCohortsGeneralFilter)

export default GroupCohortsFilterContainer;
